(() => {
  const mounted = new WeakSet();
  function mount() {
    document.querySelectorAll('[data-lore-category-video]').forEach(hero => {
      if (mounted.has(hero)) return;
      mounted.add(hero);
      const videos = Array.from(hero.querySelectorAll('.hero__video'));
      const control = hero.querySelector('[data-lore-video-control]');
      const controls = hero.querySelector('.lore-video-controls');
      const overlay = hero.querySelector('.hero__content-wrapper > .group-block > .group-block-content > .group-block');
      if (controls && overlay) {
        controls.style.setProperty('--lore-controls-width', overlay.style.getPropertyValue('--size-style-width') || '100%');
        controls.style.setProperty('--lore-controls-width-mobile', overlay.style.getPropertyValue('--size-style-width-mobile') || '100%');
        overlay.after(controls);
      }
      if (!control) return;
      const update = () => {
        const playing = videos.some(video => !video.paused && !video.ended);
        control.toggleAttribute('data-playing', playing);
        control.setAttribute('aria-label', playing ? control.dataset.pauseLabel : control.dataset.playLabel);
      };
      videos.forEach(video => { video.addEventListener('play', update); video.addEventListener('pause', update); video.addEventListener('ended', update); });
      control.addEventListener('click', () => {
        const playing = videos.some(video => !video.paused && !video.ended);
        videos.forEach(video => { if (playing) video.pause(); else video.play().catch(update); });
        update();
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
